import {Form} from "antd";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import DgForm from "../../../../custom/data-entry/form";
import Content from "./content";
import {getWeightSlipById, updateWeightSlip} from "../../../../api/weightSlip";
import {onReloadData} from "../../../../redux/actions/layout/interaction/action";

const Update = ({id, onCancel, databaseKey}) => {

    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [form] = Form.useForm()

    useEffect(() => {
        if (id)
            getWeightSlipById(id).then(r => {
                form.setFieldsValue(r)
            })
                .catch(() => {
                })
    }, [form , id])
    const onFinish = (value) => {
        updateWeightSlip(databaseKey, value).then(r => {
            dispatch(onReloadData(!reloadData))
            onCancel()
        })
            .catch(()=>{})

    }

    return (
        <>
            <DgForm
                name="basic"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
                autoComplete="off"
                form={form}
                mode={"add"}
                onFinish={onFinish}
                colon={false}
                labelAlign="left"
                scrollToFirstError={true}
            >
                <Content form={form}
                         id={id}/>

            </DgForm>
        </>
    )
}

export default Update
